/**
 * DEPRECATED: Developer mode has been replaced by the Sandbox Tenant model.
 * This hook is kept as a stub for backward compatibility — always returns false.
 */
export function useIsDevModeWithoutAuth() {
  return false;
}
